/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


(function() {

  function checkIndependenceTag(cart) {
    const fetches = cart.items.map(item =>
      fetch(`/products/${item.handle}.js`)
        .then(res => res.json())
        .then(product => {
          return product.tags.includes('Independence');
        })
        .catch(() => false)
    );

    return Promise.all(fetches).then(results => results.includes(true));
  }


  function updatePromoMessage() {
    const message = document.getElementById('promo-message');
    if (!message) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const meetsPrice = cart.total_price >= 25000;

        checkIndependenceTag(cart).then(hasTag => {
          message.style.display = (meetsPrice && hasTag)
            ? 'block'
            : 'none';
        });

      });
  }


  document.addEventListener('DOMContentLoaded', function () {
    updatePromoMessage();

    document.body.addEventListener('click', function () {
      setTimeout(updatePromoMessage, 300);
    });

    document.body.addEventListener('change', function () {
      setTimeout(updatePromoMessage, 300);
    });
  });

})();